import { forEach, head, isArray, isObject, keys } from 'lodash';

/**
/**
 * Recursively generates dot-notation paths from a nested array/object structure
 * @param array - Array of strings or nested objects to generate paths from
 * @param currentPath - The current path prefix to prepend (used in recursion)
 * @returns Array of dot-notation path strings
 * @example
 * getPopulatePaths(['a', {b: ['c', 'd']}], 'root')
 * // Returns: ['root.a', 'root.b.c', 'root.b.d']
 */
export default function getPopulatePaths(array, currentPath = '') {
  let paths = [];
  forEach(array, value => {
    if (isObject(value)) {
      const path = isArray(value) ? currentPath : `${currentPath}.${head(keys(value))}`;
      paths = paths.concat(getPopulatePaths(value, path));
    } else {
      paths.push(`${currentPath}.${value}`);
    }
  });
  return paths;
}